import request from "@/utils/request";

// 获取充值地址
export const getPayment = (data: any): any => {
  return request.post("/index/Api/getPayment", data);
};

// 获取账变记录
export const getUserAccountList = (data: any): any => {
  return request.post("/index/Api/getUserAccountList", data);
};

// 获取交易记录
export const getUserSpeedOrderList = (data: any): any => {
  return request.post("/mobile/Order/getUserSpeedOrderList", data);
};

// 获取用户提款钱包列表
export const getWalletAddr = (data: any): any => {
  return request.post("/index/Api/getWalletAddr", data);
};

// 删除钱包地址
export const delWalletAddr = (data: any): any => {
  return request.post("/index/Api/delWalletAddr", data);
};

// 添加钱包地址
export const addWallet = (data: any): any => {
  return request.post("/index/Api/addWallet", data);
};

// 上传钱包二维码图片
export const uploadImg = (data: any): any => {
  return request.post("/index/Api/uploadImg", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000, // 设置超时时间为 60 秒
  });
};

// 充值
export const recharge = (data: any): any => {
  return request.post("/index/Api/recharge", data);
};

// 提现
export const withdrawal = (data: any): any => {
  return request.post("/index/Api/withdrawal", data);
};

// 下单，合约订单
export const addcontractorder = (data: any): any => {
  return request.post("/mobile/order/addcontractorder", data);
};

// 新增合约订单挂单
export const addAutoContractOrder = (data: any): any => {
  return request.post("/mobile/order/addAutoContractOrder", data);
}

// 获取订单列表
export const getUserContractOrderList = (data: any): any => {
  return request.post("/mobile/order/getUserContractOrderList", data);
};

// 获取币种历史k线图数据
export const getHistoryData = (data: any): any => {
  return request.post("/index/Api/klines", data);
};

// 获取币种信息
export const getBiInfo = (data: any): any => {
  return request.post("/mobile/order/getBiInfo", data);
};

// 设置止盈止损
export const setContractOrder = (data: any): any => {
  return request.post("/mobile/order/setContractOrder", data);
};

// 合约订单平仓
export const endContractOrder = (data: any): any => {
  return request.post("/mobile/order/endContractOrder", data);
};

// 撤销用户合约挂单
export const cancelAutoContractOrder = (data: any): any => {
  return request.post("/mobile/order/cancelAutoContractOrder", data);
};

